import { renderToStaticMarkup } from 'react-dom/server'
import { resolveFormatter } from '~/components/echarts/formatters'
import { TooltipCircle } from '~/components/echarts/tooltip_circle'

function Tooltip({ name, value, color, formatter, percent }) {
  return (
    <div className='d-flex align-items-center mt-1'>
      <TooltipCircle color={color} />
      <div className='ps-1 me-auto'>{name}</div>
      <div className='ps-2 fw-bold'>
        {formatter(value)} ({percent}%)
      </div>
    </div>
  )
}

export function pieTooltipFormatter(formatter, currency) {
  const formatterFunction = typeof formatter === 'function' ? formatter : resolveFormatter(formatter, currency)

  return (params) => {
    const { color, name, percent, value } = params
    return renderToStaticMarkup(
      <Tooltip name={name} color={color} value={value} percent={percent} formatter={formatterFunction} />,
    )
  }
}
